import { render, staticRenderFns } from "./EquipmentBasicInfo.vue?vue&type=template&id=b0ce653a&scoped=true"
import script from "./EquipmentBasicInfo.vue?vue&type=script&lang=js"
export * from "./EquipmentBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./EquipmentBasicInfo.vue?vue&type=style&index=0&id=b0ce653a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ce653a",
  null
  
)

export default component.exports